/* eslint-disable */
import { useState } from 'react';
import propTypes from 'prop-types';


import { Flex, Alert, List, Input, Button, Progress, } from 'antd';
import { UploadOutlined, CheckCircleOutlined, ReloadOutlined } from '@ant-design/icons';

// components
import ApiCaller from '../../services/api/general';
import { translateThis } from '../../helpers/language.helper';
import { showSnackbar } from '../../components/snackbar';
import { getCategoryFromMimeType } from '../../helpers/helper.functions';
import AppIcons from '../../assets/images/icons';

import './index.scss';
import SVGIcons from '../../assets/images/icons/svgIcons';

// ........................................................................

const MultipleFileUpload = (props) => {
    const {
        folderId,
        uploadIcon = <SVGIcons.AddFileIcon />, // Upload icon
        uploadCaption = 'Upload file', // Caption for upload
        uploadURL = '',
        uploadedDocuments = [],
        onSuccess = () => null,
        onDeleteFile = () => null,
        onClose = () => null } = props;

    const [files, setFiles] = useState([]);
    const [alertMsg, setAlertMsg] = useState('');

    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files).map((file) => ({
            file,
            name: file.name,
            status: 'pending', // Track upload status
            progress: 0, // Upload progress percent
            uploading: false, // Per-file upload flag
        }));
        setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
    };

    const handleNameChange = (index, newName) => {
        setFiles((prevFiles) => {
            const updatedFiles = [...prevFiles];
            updatedFiles[index].name = newName;
            return updatedFiles;
        });
    };

    // Dummy simulated progress for UI feedback
    const simulateProgress = (index) => {
        let progress = 0;
        const interval = setInterval(() => {
            setFiles((prevFiles) => {
                const updated = [...prevFiles];
                if (updated[index].progress >= 90 || !updated[index].uploading) {
                    clearInterval(interval);
                    return updated;
                }
                updated[index].progress = Math.min(updated[index].progress + 10, 90);
                return updated;
            });
            progress += 10;
        }, 1000);
    };

    const uploadFile = async (fileData, index) => {
        setFiles((prevFiles) => {
            const updated = [...prevFiles];
            updated[index].uploading = true;
            updated[index].status = 'uploading';
            updated[index].progress = 0;
            return updated;
        });
        // simulateProgress(index);

        try {
            const file = fileData.file;
            const fileName = fileData.name;
            const { size, type } = file;
            const formattedFileType = getCategoryFromMimeType(type);
            const formData = new FormData();
            formData.append('files', file);
            formData.append('title', fileName);
            formData.append('type', formattedFileType);

            const apiCaller = new ApiCaller(`${uploadURL}`);
            const fileUploadResult = await apiCaller.postData(formData);
            if (fileUploadResult.success) {
                // Upload completed
                setFiles((prevFiles) => {
                    const updated = [...prevFiles];
                    updated[index].progress = 100;
                    updated[index].uploading = false;
                    updated[index].status = 'uploaded';
                    return updated;
                });
                setAlertMsg(`${fileName} uploaded successfully!`);

                return { success: true };
            } else {
                // Upload failed
                setFiles((prevFiles) => {
                    const updated = [...prevFiles];
                    updated[index].uploading = false;
                    updated[index].progress = 0;
                    updated[index].status = 'failed';
                    return updated;
                });
                return false;
            }
        } catch (error) {
            console.error('Upload error:', error);
            setFiles((prevFiles) => {
                const updated = [...prevFiles];
                updated[index].uploading = false;
                updated[index].progress = 0;
                updated[index].status = 'failed';
                return updated;
            });
            return false;
        }
    };

    const uploadAllFiles = async () => {
        setAlertMsg('');
        const uploadPromises = files.map((file, index) =>
            file.uploading || file.status === 'uploaded'
                ? Promise.resolve() // skip already uploading or uploaded
                : uploadFile(file, index)
        );
        const results = await Promise.all(uploadPromises);
        const success = results.every((res) => res === undefined || res?.success);
        setAlertMsg(success ? 'All files uploaded successfully!' : 'Some files failed to upload.');
        if (success) {
            onSuccess();
            setFiles([]);

        }
    };

    const uploadSingleFile = async (fileData, index) => {
        if (files[index].uploading) return; // Prevent double trigger
        setAlertMsg('');
        const result = await uploadFile(fileData, index);
        if (result?.success) {
            setAlertMsg(`File "${fileData.name}" uploaded successfully!`);
            onSuccess();
            setFiles((prev)=>prev.filter((f)=>f.name !== fileData.name));
        } else {
            setAlertMsg(`Failed to upload "${fileData.name}".`);
        }
    };

    const retryUpload = async (fileData, index) => {
        await uploadSingleFile(fileData, index);
    };

    const deleteFile  = (fileName)=>{
        setFiles((files)=>files.filter((f)=>f.name !== fileName));
        onDeleteFile(fileName);
    }

    return (
        <div className="multiple-file-upload f-wrp" style={{ marginTop: '10px' }}>
            <Flex className="file-upload-box" vertical>
                {alertMsg && (
                    <Alert
                        message={alertMsg}
                        type={alertMsg.includes('successfully') ? 'success' : 'error'}
                        closable
                        onClose={() => setAlertMsg('')}
                    />
                )}

                {files.length || uploadedDocuments.length ? (<div className='uploaded-file-wrp f-wrp'>
                    <div className='flex-box ai-module-upload-box'>
                        {files.map((fileData, index) => (
                            <div key={index} sx={{ flexDirection: 'column', alignItems: 'stretch' }} className='each-module-items'>
                                <div className='module-item'>
                                    <div className='file-title'>

                                        <span className='icon-box'> <img src={AppIcons.fileIcon} alt='file-icon' /></span>

                                        <div className='ant-form-item' sx={{ flexGrow: 1 }}>
                                            <Input className='ant-input'
                                                value={fileData.name}
                                                onChange={(e) => handleNameChange(index, e.target.value)}
                                                variant="outlined"
                                                fullWidth
                                                size="small"
                                                disabled={fileData.uploading}
                                            />
                                        </div>
                                    </div>
                                    {fileData.status === 'failed' ? (
                                        <Button
                                            variant="outlined"
                                            color="error"
                                            onClick={() => retryUpload(fileData, index)}
                                            disabled={fileData.uploading}
                                        >
                                            <ReloadOutlined />
                                        </Button>
                                    ) : fileData.status === 'uploaded' ? (
                                        <>
                                            <Button
                                                disabled
                                                variant="contained"
                                                color="primary"
                                                startIcon={<CheckCircleOutlined />}
                                            >
                                                <CheckCircleOutlined />
                                            </Button>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                onClick={() => deleteFile(fileData.name)}
                                            >
                                                <SVGIcons.CloseIcon />
                                            </Button>
                                            
                                        </>
                                    ) : (
                                        <Button
                                            loading={fileData.uploading}
                                            disabled={!folderId || fileData.status === 'uploaded'}
                                            variant="contained"
                                            color="primary"
                                            onClick={() => uploadSingleFile(fileData, index)}
                                            startIcon={<UploadOutlined />}
                                        >
                                            <UploadOutlined />
                                        </Button>
                                    )}
                                </div>
                            </div>
                        ))}
                        {uploadedDocuments.map((img, i) => (
                            <div key={`${i}-${img.title}`} className='each-module-items'>
                                <div className='module-item'>
                                    <div className='file-title'>
                                        <span className='icon-box'> <img src={AppIcons.fileIcon} alt='file-icon' /></span>
                                        <p>{img?.title ?? img?.originalName}</p>
                                    </div>
                                    {/* <Button
                                        disabled
                                        variant="contained"
                                        color="primary"
                                        startIcon={<CheckCircleOutlined />}
                                    >
                                        <CheckCircleOutlined />
                                    </Button> */}
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => deleteFile(img?.title || img?.originalName)}
                                    >
                                        <SVGIcons.CloseIcon />
                                    </Button>
                                </div>
                            </div>
                        ))}
                    </div>
                    {files.length ? <Button
                        variant="contained"
                        color="secondary"
                        icon={<UploadOutlined />}
                        onClick={uploadAllFiles}
                        disabled={files.length === 0 || !folderId}
                        className='upload-file-btn sm-icon-btn'
                    >
                        Upload All
                    </Button> : null}
                </div>) : null}

                <div className="uploadBox f-wrp">
                    <label htmlFor="addEditFileUpload" className='upload-file-btn' >
                        {/* {translateThis('Add file')} */}
                        {uploadIcon}
                        {uploadCaption}
                    </label>
                    <input
                        id="addEditFileUpload"
                        type="file"
                        multiple
                        onChange={handleFileChange}
                        style={{ marginBottom: '20px' }}
                    />
                </div>
            </Flex>
        </div>
    );
};

MultipleFileUpload.propTypes = {
    uploadURL: propTypes.string,
    uploadIcon: propTypes.any,
    uploadedDocuments: propTypes.any,
    uploadCaption: propTypes.string,
    folderId: propTypes.string.isRequired,
    onClose: propTypes.func,
    onSuccess: propTypes.func,
};

export default MultipleFileUpload;
